import { ICreateVenue } from "../hooks/useCreateNewVenue";
import ILocationAPIObject from "../interfaces/ILocationAPI";
import { HTTPMethods } from "../yoello-lib/modules/API/API";
import IVenue from "../yoello-lib/modules/API/interfaces/IVenue";
import { ICallAPIFunction } from "../yoello-lib/modules/API2/types";

type CallLocations = ICallAPIFunction<ILocationAPIObject>;

type CallVenues = ICallAPIFunction<IVenue>;


export async function createNewVenue(
    callLocations: CallLocations,
    callVenue: CallVenues,
    state: ICreateVenue) {

    const location = await createLocaton(callLocations, state);

    //@ts-ignore
    delete state?.venue_location
    const venue = await createVenue(callVenue, state, location?.id!);
    return {
        location,
        venue,
    }
}



async function createLocaton(callLocations: CallLocations, state: ICreateVenue) {
    const newLocations = {
        longitude: 0,
        latitude: 0,
        map_id: Math.floor((Math.random() * 10000000) + 1).toString(),
        location_name: "",
        address_building: "",
        address_number: "",
        address_city: "",
        address_country: state?.venue_location?.value,
        address_postcode: ""
    }
    const { isSuccessful, data } = await callLocations(HTTPMethods.POST, {
        body: newLocations
    })
    console.log(isSuccessful, data);
    if (isSuccessful) {
        return data;
    } else {
        throw data;
    }
}

async function createVenue(callVenues: CallVenues, state: Partial<ICreateVenue>, locationId: string) {
    const newVenue = {
        ...state,
        venue_data: {
            ...state.venue_data,
            location_id: locationId,
        }
    }
    const { isSuccessful, data } = await callVenues(HTTPMethods.POST, {
        body: newVenue
    })
    if (isSuccessful) {
        return data;
    } else {
        throw data;
    }
}

